import theaurum from "../../../../public/projects/4s/images/4stheaurum.webp";
import logo from "../../../../public/projects/4s/images/logo/logo.png";
import overviewImage from "../../../../public/projects/4s/images/Overview/1.webp";
import bannerDesktopImage from "../../../../public/projects/4s/images/Banner/1.webp";
import bannerMobileImage from "../../../../public/projects/4s/images/Banner/2.webp";
import siteVisitBannerImage from "../../../../public/projects/4s/images/SiteVisitBanner/1.webp";
import Location from "../../../../public/projects/4s/images/Location/L1.webp";
import Hightlights from "../../../../public/projects/4s/images/Highlights/1.webp";
import image1BHK from "../../../../public/projects/4s/images/floorplan/1.webp";
// import image2BHK from "../../../../public/projects/4s/images/floorplan/2.webp";
// import image3BHK from "../../../../public/projects/4s/images/floorplan/3.webp";
import location from "../../../../public/projects/4s/images/Overview/l.png";
import cal from "../../../../public/projects/4s/images/Overview/c.png";
import newlaunch from "../../../../public/projects/4s/images/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import image1 from "../../../../public/projects/4s/images/Gallery/1.webp";
import image2 from "../../../../public/projects/4s/images/Gallery/2.webp";
import image3 from "../../../../public/projects/4s/images/Gallery/3.webp";
import image4 from "../../../../public/projects/4s/images/Gallery/4.webp";
import image5 from "../../../../public/projects/4s/images/Gallery/5.webp";


export const developers4S = {
  properties: [
    {
      name: "4S - The Aurrum",
      developer: "4S",
      image: theaurum,
      price: "On Request",
      state: "Gurugram",
      projectlocation: "Golf Course Extension Road",
      location: "Sector 59,",
      bed: "3- 4 BHK",
      size: "....",
      url: ``,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};

export const Headers={
  logo:logo,
  data:
    {
      experience:`2014`,
      projects:`118`,
      ongoingprojects:`10`
    },
  about:`4S Developers is a reputed real estate company known for delivering premium residential and 
  commercial projects. With a focus on innovation, quality construction, and timely delivery, the company emphasizes 
  creating spaces that blend modern design with functionality. 4S Developers are committed to customer satisfaction 
  and sustainable urban development.`,
};
// Gallary data
export const projects4s = {
  fourstheauram: {
    bannerdata:{
      bannerDesktopImage,
      bannerMobileImage,
      textOverlay: "",
      data:{
        title:"4S The Auram",
        subtitle:"Sector 59, Gurgaon",
        starting_price:"On Request",
        rerano:"",
        payment_plan:"....",
        status:"New Launch"
      }
    },
    overview: {
      heading: "Discover Luxury Living at 4s The Aurrum",
      description: [
        "4S Group's ultra-luxurious residential development, 4S The Aurrum, is situated along Golf Course Extension Road in Sector 59 in Gurgaon. This property, which spans about 10.5 acres with 80% open green area, offers luxurious 3 and 4 BHK apartments in a range of sizes. The sizes of the 3 BHK and 4 BHK apartments range from 2407 to 2624 square feet and 3562 square feet, respectively.",
        "Every apartment is designed with premium fixtures and facilities to provide a comfortable and opulent living space.",
      ],
      image: overviewImage,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal,
          title: "....",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK Small",
          area: "2407 sq. ft.",
          price: "5.2 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK Large",
          area: "2624 sq. ft.",
          price: "5.7 Cr*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "3562 sq. ft.",
          price: "7.8 Cr*",
          eoiAmount: "On Request",
        },
      ],
    },
    floor_plan: [
      {
        type: "3 BHK Small",
        area: "2407 sq. ft.",
        price: "On Request",
        image: image1BHK,
      },
    ],
    highlights: {
      images: Hightlights,
      tagline: "Highlights",
      features: [
        "Every home has three sides that are open, providing panoramic views and lots of natural light.",
        "Each tower has four lifts and two private elevators, giving you direct access to your home while maintaining convenience and privacy.",
        "Every unit has a video door phone so that residents can check who is coming before letting them in.",
        "Apartments have 11-foot ceilings, which create an opulent, roomy atmosphere.",
        "Numerous apartments provide occupants with 270-degree unrestricted views, enabling them to take in vast Aravali landscapes.",
      ],
    },
    location: {
      image: Location,
      places: [
        { place: "Neighbourhood Of Boutique Golf Courses" },
        { place: "Close Proximity To Aravalli Hills" },
        { place: "2.8 KM : Rapid Metro Station" },
        { place: "3.2 KM : From Heritage Xperiential School" },
      ],
    },
    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: image1 },
        { image: image2 },
        { image: image3 },
        { image: image4 },
        { image: image5 },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in 4S The Auram, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],

    similar:{
      properties: [
        {
          name: "4S - The Aurum",
          developer: "4S",
          image: theaurum,
          price: "On Request",
          state: "Gurugram",
          projectlocation: "Golf Course Extension Road",
          location: "Sector 59,",
          bed: "3- 4 BHK",
          size: "....",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
     },
  },
};
            